import React from 'react';
import { Link } from 'react-router-dom';

/** Parámetros de ejemplo (sin persistencia). */
const MOCK_PARAMS = [
  { key: 'Zona horaria planta', value: 'America/Mexico_City', note: 'Para etiquetas y turnos' },
  { key: 'Rendimiento objetivo diario', value: '120 %', note: 'Meta de línea principal' },
  { key: 'Etiqueta nutricional', value: 'NOM-051', note: 'Norma de referencia' },
];

const MOCK_TURNS = [
  { id: 1, name: 'Matutino', start: '06:00', end: '14:00' },
  { id: 2, name: 'Vespertino', start: '14:00', end: '22:00' },
  { id: 3, name: 'Nocturno', start: '22:00', end: '06:00' },
];

const ConfiguracionProduccionIndex = () => {
  return (
    <div className="p-6 max-w-5xl">
      <nav className="text-sm text-gray-600 mb-4">
        <Link to="/dashboard" className="hover:text-teal-600">
          Dashboard
        </Link>
        <span className="mx-2">/</span>
        <Link to="/produccion-concesionaria" className="hover:text-teal-600">
          Producción concesionaria
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-800">Configuración</span>
      </nav>

      <h1 className="text-2xl font-semibold text-gray-800">Configuración</h1>
      <p className="mt-1 text-sm text-gray-500">
        Vista previa con datos de ejemplo. Aquí podrá enlazar parámetros reales del módulo (turnos, líneas, normas,
        etc.).
      </p>

      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          to="/produccion-concesionaria/configuraciones/almacenes-producto-terminado"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-teal-200 bg-teal-50 text-teal-800 text-sm font-medium hover:bg-teal-100"
        >
          🏭 Almacenes PT (crear por almacén principal)
        </Link>
        <Link
          to="/produccion-concesionaria/configuraciones/tiempos"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-teal-200 bg-teal-50 text-teal-800 text-sm font-medium hover:bg-teal-100"
        >
          🕐 Tiempos (activar desayuno, almuerzo, cena)
        </Link>
        <Link
          to="/produccion-concesionaria/configuraciones/tipo-plato"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-teal-200 bg-teal-50 text-teal-800 text-sm font-medium hover:bg-teal-100"
        >
          🍽️ Tipo de plato
        </Link>
        <Link
          to="/produccion-concesionaria/configuraciones/area-despacho"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-teal-200 bg-teal-50 text-teal-800 text-sm font-medium hover:bg-teal-100"
        >
          📤 Área de despacho
        </Link>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-2">
        <section className="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
          <h2 className="font-semibold text-gray-900 flex items-center gap-2">
            <span>⚙️</span> Parámetros generales (ejemplo)
          </h2>
          <ul className="mt-4 space-y-3">
            {MOCK_PARAMS.map((p) => (
              <li key={p.key} className="border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                <div className="text-sm font-medium text-gray-800">{p.key}</div>
                <div className="text-teal-700 font-mono text-sm">{p.value}</div>
                <div className="text-xs text-gray-500">{p.note}</div>
              </li>
            ))}
          </ul>
        </section>

        <section className="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
          <h2 className="font-semibold text-gray-900 flex items-center gap-2">
            <span>🕐</span> Turnos (ejemplo)
          </h2>
          <div className="mt-4 overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b">
                  <th className="pb-2 pr-4">Turno</th>
                  <th className="pb-2 pr-4">Inicio</th>
                  <th className="pb-2">Fin</th>
                </tr>
              </thead>
              <tbody>
                {MOCK_TURNS.map((t) => (
                  <tr key={t.id} className="border-b border-gray-50">
                    <td className="py-2 pr-4 text-gray-800">{t.name}</td>
                    <td className="py-2 pr-4 font-mono text-gray-600">{t.start}</td>
                    <td className="py-2 font-mono text-gray-600">{t.end}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ConfiguracionProduccionIndex;
